const descMenu = {   
    advertMenu: document.getElementById('advertMenu'),
    advertWrap: document.querySelectorAll('.jsAdvertWrap'),
    preventClicks: document.querySelectorAll('.jsPreventClick'),

    init() {
        if(window.innerWidth > 1200) {
            this.setImg();
        }
        this.preventClick();
    },
    preventClick() {
        this.preventClicks.forEach(item=>{
            item.addEventListener('click', (e)=>{
                e.preventDefault(); 
                e.stopImmediatePropagation()
             
            }, true)
        })
    },
    setImg() {        
        this.advertWrap.forEach(item => {                  
            item.innerHTML = this.advertMenu.innerHTML;
        })        
    }

}

export default descMenu;